import { Button, Col, Row } from "rsuite";
import { useNavigate } from "react-router-dom";
import { Carousel } from "rsuite";
import Cover3 from "../assets/images/2025091703.png";
import Cover4 from "../assets/images/2025091704.png";

import styles from "./style.module.css"

export default function HomeLegacy() {
  const navigate = useNavigate();

  return (<>
    <Carousel autoplay className={styles.myCarousel}>
      {/* <img src={Cover1} alt="cover1" />
      <img src={Cover2} alt="cover2" /> */}
      <img src={Cover3} alt="cover3" />
      <img src={Cover4} alt="cover4" />
    </Carousel>
    <br></br>
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '2rem 1rem' }}>
      {/* Carousel Section */}

      {/* Main Call-to-Action */}
      {/* <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <Button appearance="primary" size="lg" style={{ padding: '12px 32px', fontSize: '1.2rem', borderRadius: 8 }} onClick={() => navigate('/rider/order/create')}>
          立即預約
        </Button>
      </div> */}

      {/* Service Highlights */}
      <Row gutter={24} style={{ marginBottom: '2rem', justifyContent: 'center' }}>
        <Col xs={24} sm={12} md={6} style={{ marginBottom: 16 }}>
          <Button block appearance="ghost" style={{ height: 60, fontSize: '1rem', borderRadius: 8, borderColor: '#0ea5a4', color: '#0ea5a4' }} onClick={() => navigate('/rider/order/create')}>
            預約機場接機
          </Button>
        </Col>
        <Col xs={24} sm={12} md={6} style={{ marginBottom: 16 }}>
          <Button block appearance="ghost" style={{ height: 60, fontSize: '1rem', borderRadius: 8, borderColor: '#0ea5a4', color: '#0ea5a4' }} onClick={() => navigate('/rider/order/create')}>
            預約機場送機
          </Button>
        </Col>
        <Col xs={24} sm={12} md={6} style={{ marginBottom: 16 }}>
          <Button block appearance="ghost" style={{ height: 60, fontSize: '1rem', borderRadius: 8, borderColor: '#0ea5a4', color: '#0ea5a4' }} onClick={() => navigate('/rider/order/create')}>
            短中長途
          </Button>
        </Col>
        <Col xs={24} sm={12} md={6} style={{ marginBottom: 16 }}>
          <Button block appearance="ghost" style={{ height: 60, fontSize: '1rem', borderRadius: 8, borderColor: '#0ea5a4', color: '#0ea5a4' }} onClick={() => navigate('/rider/order/create')}>
            海外接送
          </Button>
        </Col>
      </Row>
    </div>
  </>
  );
}